import { render, staticRenderFns } from "./TheCartSection.vue?vue&type=template&id=6f63af06&scoped=true&name=the-cart-section&"
import script from "./TheCartSection.vue?vue&type=script&lang=js&"
export * from "./TheCartSection.vue?vue&type=script&lang=js&"
import style0 from "./TheCartSection.vue?vue&type=style&index=0&id=6f63af06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f63af06",
  null
  
)

/* custom blocks */
import block0 from "./TheCartSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports